let bankTab = document.getElementsByClassName('bank-tab')[0];
let dcTab = document.getElementsByClassName('dc-tab')[0];
let amountSection = document.getElementsByClassName('calculation')[0];
let pricingCalcForm = document.querySelector('#pricing-calculator-form');


pricingCalcForm.addEventListener('submit', event => {
    event.preventDefault();
  });

let isBankTabActive = true;

let input = pricingCalcForm.querySelector('#calc-pricing-input');
let amount = document.querySelector('.calculation #amount');
let fee = document.querySelector('.calculation #fee');

input.oninput = function() {
  if (this.value.length > 8) {
    this.value = this.value.slice(0, 8);
  }
};

document
  .getElementById('calc-pricing-btn')
  .addEventListener('click', function() {
    let charges;
    if (isBankTabActive) {
      let transactionCharge = Math.min(Number(input.value) / 100, 50);
      charges = transactionCharge + (Number(transactionCharge) * 18) / 100;
    } else {
      let transactionCharge = (Number(input.value) * 2) / 100;
      charges = transactionCharge + (transactionCharge * 18) / 100;
    }
    amount.innerText = "₹" + (Number(input.value) - charges).toLocaleString('en-IN', {minimumFractionDigits: 2});
    fee.innerText = "₹" + Number(charges).toLocaleString('en-IN', {minimumFractionDigits: 2});
    if (input.value) amountSection.classList.remove('hide');
  });

bankTab.addEventListener('click', () => {
  isBankTabActive = true;
  reset();
  bankTab.classList.add('active');
  dcTab.classList.remove('active');
  document.getElementById('bank-rate').classList.remove('hide');
  document.getElementById('dc-rate').classList.add('hide');
});

dcTab.addEventListener('click', () => {
  reset();
  isBankTabActive = false;
  dcTab.classList.add('active');
  bankTab.classList.remove('active');
  document.getElementById('dc-rate').classList.remove('hide');
  document.getElementById('bank-rate').classList.add('hide');
});

function reset() {
  input.value = '';
  amount.innerText = '';
  fee.innerText = '';
  amountSection.classList.add('hide');
}
